var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "vs-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.currentOrderedItems,
            "no-data-text": "Aucune donnée disponible",
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ data }) {
                return _vm._l(data, function (item, i) {
                  return _c(
                    "tr",
                    {
                      key: i,
                      class:
                        !!_vm.dragging && _vm.dragging.id == item.id
                          ? "dragging"
                          : "waiting-drag",
                      attrs: { data: item },
                    },
                    [
                      _c("vs-td", [
                        _c("div", {
                          staticClass: "drag-icon",
                          attrs: { draggable: "true" },
                          on: {
                            dragstart: function ($event) {
                              return _vm.dragStart(item, $event)
                            },
                            dragover: function ($event) {
                              return _vm.dragOver(item.order, $event)
                            },
                            drop: function ($event) {
                              return _vm.drop(item.order, $event)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.table.columns, function (column) {
                        return _c(
                          "vs-td",
                          {
                            key: column.name,
                            attrs: { data: _vm.data_get(item, column.name) },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.data_get(item, column.name)) +
                                "\n                "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                })
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "thead" },
            [
              _c("vs-th", { staticStyle: { width: "15px" } }),
              _vm._v(" "),
              _vm._l(_vm.table.columns, function (column) {
                return _c("vs-th", { key: column.name }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(column.label) +
                      "\n            "
                  ),
                ])
              }),
            ],
            2
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }